document.addEventListener('DOMContentLoaded', () => {

  // ==========================================
  // スムーススクロール（ヘッダー高さ調整）
  // ==========================================

  const isSP = window.matchMedia("(max-width: 767px)").matches;
  const headerHeight = isSP ? 73 : 80;
  const scrollSpeed = isSP ? 200 : 250;

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      const target = href === "#" || href === ""
        ? document.documentElement
        : document.querySelector(href);

      if (!target) return;

      e.preventDefault();

      const position = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;

      window.scrollTo({
        top: position,
        behavior: "smooth"
      });
    });
  });


  // ==========================================
  // 別ページからアンカー付きで来た場合
  // ==========================================

  window.addEventListener("load", () => {
    const hash = location.hash;
    if (!hash) return;

    const target = document.querySelector(hash);
    if (!target) return;

    const headerHeight = window.matchMedia("(max-width: 767px)").matches ? 50 : 86;
    const position = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;

    window.scrollTo(0, position);
  });


  // ==========================================
  // フェードイン系
  // ==========================================

  const fadeInElements = () => {
    const scroll = window.scrollY;
    const height = window.innerHeight;
    const scrollPos = scroll + height * 0.8;

    document.querySelectorAll('.js-show').forEach(el => {
      if (el.getBoundingClientRect().top + window.pageYOffset < scrollPos) {
        el.style.opacity = 1;
        el.style.transform = 'translate(0, 0)';
        el.classList.add('is-active');
      }
    });

    document.querySelectorAll('.js-show-zoom').forEach(el => {
      if (el.getBoundingClientRect().top + window.pageYOffset < scrollPos) {
        el.style.transform = 'scale(1)';
        el.classList.add('is-active');
      }
    });

    document.querySelectorAll('.js-anim').forEach(parent => {
      if (parent.getBoundingClientRect().top + window.pageYOffset < scrollPos) {
        parent.querySelectorAll('.js-show').forEach(el => {
          el.style.opacity = 1;
          el.style.transform = 'translate(0, 0)';
        });
        parent.querySelectorAll('.js-show-zoom').forEach(el => {
          el.style.transform = 'scale(1)';
        });
        parent.classList.add('is-active');
      }
    });

    document.querySelectorAll('.js-clip').forEach(el => {
      if (el.getBoundingClientRect().top + window.pageYOffset < scrollPos) {
        el.classList.add('is-active');
      }
    });
  };

  window.addEventListener('scroll', fadeInElements);
  window.addEventListener('load', fadeInElements);

});




// 390px以下スケーリング
// ________________________________________________________
(function () {
  const viewport = document.querySelector('meta[name="viewport"]');
  if (!viewport) return;

  const setViewport = () => {
    const value = window.innerWidth > 390
      ? 'width=device-width,initial-scale=1'
      : 'width=390';

    viewport.setAttribute('content', value);
  };

  setViewport(); // 初回のみ
})();



// swiper-story
// ________________________________________________________
function initStorySwipers() {
  function setupSwiper({ selector, nextBtnClass, prevBtnClass }) {
    var swiperElement = document.querySelector(selector);
    if (!swiperElement) return;

    // var swiper = new Swiper(selector, {
    //   slidesPerView: 1.15,
    //   spaceBetween: 16,
    //   centeredSlides : true,
    //   threshold:10,
    //   speed: 800,
    //   loop: true,
    //   autoplay: {
    //     delay: 3000,
    //     disableOnInteraction: false,
    //     pauseOnMouseEnter: true,
    //   },
    //   breakpoints: {
    //     768: {
    //       slidesPerView: 3,
    //       spaceBetween: 20,
    //     },
    //     1024: {
    //       slidesPerView: 3,
    //       spaceBetween: 40,
    //     },
    //   },
    //   // ページネーション
    //   pagination: {
    //     el: ".swiper-pagination",
    //     clickable: true,
    //   },
    //   navigation: {
    //     nextEl: nextBtnClass,
    //     prevEl: prevBtnClass,
    //   },
    // });
    
    var swiper = new Swiper(selector, {
      slidesPerView: 1.15,
      spaceBetween: 16,
      centeredSlides : true,
      loop: true,
      speed: 800,
      threshold: 10,
      breakpoints: {
        768: {
          slidesPerView: "auto",
          spaceBetween: 20,  // ← 中央寄せ
        },
        1024: {
          slidesPerView: "auto",
          spaceBetween: 40,  // ← 中央寄せ
        },
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: nextBtnClass,
        prevEl: prevBtnClass,
      },
    });

  }

  setupSwiper({
    selector: ".swiper-story",
    nextBtnClass: ".story-next",
    prevBtnClass: ".story-prev",
  });

}

document.addEventListener("DOMContentLoaded", function () {
  initStorySwipers();
});


// modal
// ________________________________________________________
document.addEventListener('DOMContentLoaded', function () {

  const modal = document.querySelector('.js-lineup-modal');
  const modalImage = document.querySelector('.js-modal-image');
  const openBtns = document.querySelectorAll('.js-lineup-open');
  const closeBtns = document.querySelectorAll('.js-modal-close');

  if (!modal) return;

  // 開く
  openBtns.forEach(btn => {
    btn.addEventListener('click', function () {

      const pc = btn.dataset.pc;
      const sp = btn.dataset.sp;

      modalImage.innerHTML = `
        <picture>
          <source media="(max-width: 767px)" srcset="${sp}">
          <img src="${pc}" alt="">
        </picture>
      `;

      modal.classList.add('is-active');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });
  });

  // 閉じる
  closeBtns.forEach(btn => {
    btn.addEventListener('click', closeModal);
  });

  function closeModal() {
    modal.classList.remove('is-active');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

});
